import { useEffect, useState } from 'react';

import { useDocumentTitle } from 'hooks/document-title';
import ReactGA from 'react-ga4';

import { Error } from './Error';

const REDIRECT_ATTEMPTED_KEY = 'checkmate_error_redirect_attempted';

const Error500 = () => {
  useDocumentTitle('Server Error | Checkmate');
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.pathname,
      title: '500 Server Error',
    });

    if (sessionStorage.getItem(REDIRECT_ATTEMPTED_KEY)) {
      sessionStorage.removeItem(REDIRECT_ATTEMPTED_KEY);
      setChecking(false);
      return;
    }

    fetch(`${process.env.REACT_APP_API_URl}/health_check`)
      .then(response => {
        if (response.ok) {
          sessionStorage.setItem(REDIRECT_ATTEMPTED_KEY, 'true');
          window.location.href = `${process.env.REACT_APP_WEB_URL}/`;
        } else {
          setChecking(false);
        }
      })
      .catch(() => {
        setChecking(false);
      });
  }, []);

  if (checking) return null;

  return <Error>500</Error>;
};

export default Error500;
